/**
 * A slice whose value only exists once its first response lands. Redux needs an
 * initial value, and every reader is written against the loaded shape rather
 * than a nullable one, so an empty object stands in until then.
 *
 * This is `satisfiesAsPartial` for production code: the same widening, kept
 * separate so the test helper does not leak into the app. The agent models its
 * own auth user the same way, as `partialUserData`.
 */
export const emptyUntilLoaded = <Type>(): Type =>
  // biome-ignore lint/plugin: the one audited widening for an unloaded slice.
  ({}) as Type;
